import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson1DefaultStartCode = `%lang starknet

// Cairo hints can be useful for delegating heavy computation.
// This pattern is at the very heart of Cairo: verification is much faster than computation.
// However, as hints are not part of the final Cairo bytecode, a malicious program may provide wrong results.
// You should always verify computations done inside hints.


// TODO: Compute the result of "x modulo n" inside a hint using python's 'divmod'
// Don't forget to make sure the result is correct.
${doNotModifyCodeAbove}`;

export const lesson1DefaultMiddleCode = `func modulo(x : felt, n : felt) -> (mod : felt) {
    alloc_locals;
    local quotient;
    local remainder;
    %{
        # TODO: Compute the quotient and remainder inside the hint
        print(ids.quotient)
        print(ids.remainder)
    %}
    // TODO: verify the result is correct

    return (mod=0);
}`;

export const lesson1DefaultEndCode = `${doNotModifyCodeBelow}
@external
func test_modulo{syscall_ptr : felt*}() {
    let x1 = 5;
    let n1 = 2;
    let (mod1 : felt) = modulo(x1, n1);
    assert 1 = mod1;

    let x2 = 51;
    let n2 = 7;
    let (mod2 : felt) = modulo(x2, n2);
    assert 2 = mod2;

    let x3 = 125;
    let n3 = 11;
    let (mod3 : felt) = modulo(x3, n3);
    assert 4 = mod3;

    return ();
}`;
